import React from 'react';
import { JSX } from '@ionic/core/components';
import { StyledSpecialistProfileVideoModal } from './SpecialistProfileVideoModal.style';
import { IonAlert } from '@ionic/react';
import { VideoPlayer } from '@mindly/ui-components';

type SpecialistProfileVideoModalProps = {
  videoLink: string;
  closeModalHandler?: () => void;
} & JSX.IonModal;

const SpecialistProfileVideoModal: React.FC<SpecialistProfileVideoModalProps> = (props) => {
  const errorContent = (
    <IonAlert
      isOpen={true}
      onDidDismiss={props.closeModalHandler}
      header="Помилка"
      message="Нажаль відео не доступне"
      mode={'ios'}
      buttons={[
        {
          text: 'Oк',
          handler: props.closeModalHandler,
        },
      ]}
    />
  );

  return (
    <StyledSpecialistProfileVideoModal {...props}>
      <VideoPlayer
        videoLink={props.videoLink}
        closeModalHandler={props.closeModalHandler}
        onErrorContent={errorContent}
      />
    </StyledSpecialistProfileVideoModal>
  );
};

export default SpecialistProfileVideoModal;
